import { useMediaQuery } from "@mui/material";
import { Box } from "@mui/system";
import Footer from "../LandingPage/Footer";
import WhatAppMobile from "../LandingPage/WhatAppMobile";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import NavBar from "../../Navigation/NavBar";

function RefundPolicy() {
    const isXs = useMediaQuery('(min-width:600px)');
    return (
        <>
              <WhatAppMobile/>
              <NavBar/>

            <Box style={{ width: '100%' }}>
                <Box style={{ width: '100%' }}>
                <div style={{ backgroundColor: '#CB8B65', display: 'flex', alignItems: 'center', paddingLeft: isXs ?'6rem':'1rem', gap:'10px', height:'50px'}}> 
  <div><a style={{ color: 'white', textDecoration: 'none', fontSize:'1rem' }} href="/">Home</a></div><ArrowForwardIosIcon style={{fontSize:'14px', color:'white'}}/>
  <div style={{fontSize:'1rem ', color:'white'}}>Refund Policy</div></div>


                    <Box style={{ paddingLeft:isXs? '6rem':'1rem', paddingTop:'3rem', display: 'flex', flexDirection: 'column', gap: '1.3rem', width: isXs?'70%':'100%',paddingBottom:'15rem' }}>
                        <Box>
                            <h1 style={{ fontSize: '1.2rem', fontWeight: 600 }}>Refund Policy for Kanha Home Tutions</h1>
                        </Box>
                        <Box>
                            <p>
                            Please note that payments made through our Tutor App are non-refundable. We do not offer refunds under any circumstances. All transactions are final.
                            </p>
                        </Box>
                        <Box>
                            <h1 style={{ fontSize: '1.2rem', fontWeight: 600 }}>1. Final Sale</h1>
                        </Box>
                      
                        <Box>
                            <p>
                            All payments for services, subscriptions, or any in-app purchases are considered final and non-refundable.
                            </p>
                        </Box>
                    
                        <Box>
                            <h1 style={{ fontSize: '1.2rem', fontWeight: 600 }}>2. No Exceptions</h1>
                        </Box>
                        <Box>
                            <p>
                            Refunds will not be issued for unused services, subscription periods, or any other reason.
                            </p>
                        </Box>

                        <Box>
                            <h1 style={{ fontSize: '1.2rem', fontWeight: 600 }}>3. Service Interruptions</h1>
                        </Box>
                        <Box>
                            <p>Payments will not be refunded in case of temporary service interruptions or technical issues. We are committed to resolving any issues promptly.</p>
                        </Box>
                      

                        <Box>
                            <h1 style={{ fontSize: '1.2rem', fontWeight: 600 }}>4. Dispute Resolution</h1>
                        </Box>
                        <Box>
                            <p>
                            In case of any disputes, please contact our support team. We aim to address all concerns and provide assistance to ensure a satisfactory resolution.
                            For any queries or issues, please contact our support team for assistance.
                            </p>
                        </Box>
<Box style={{ lineHeight: '2rem' }}>
    <p> Contact Information:</p>
                            <ul>
                            
                                <li>Email: kanhahometutions@gmail.com
                                </li>
                                <li>
                                  Helpline No.: +91-9166100755
                                </li>
                            </ul>
                        </Box>
                        
                    </Box>
                    <Box style={{ marginTop: '2rem', textAlign: 'center', fontWeight: 600 }}>
                        <p>
                            By using the Website and our services, you consent to the terms of this Refund Policy.
                        </p>
                    </Box>
                </Box>
            </Box>
           <Footer/>
        </>
    );
}

export default RefundPolicy;
